<div fxLayout="row wrap">
  <Teranet-PageTitle [PageTitle]="'Edit Holiday'"></Teranet-PageTitle>
  <mat-divider></mat-divider>
</div>
<div mat-dialog-content>
  <div fxLayout="column">
    <div class="teranet-padding" fxFlex="100" fxLayout="column">
      <form #editHolidayForm="ngForm"
            (ngSubmit)="onSubmit()"
            [formGroup]="editHolidayFormGroup"
            novalidate>
        <div fxFlex="100">
          <div fxLayout="column" fxLayoutAlign="center stretch">
            <div class="form-group-flex-column">
              <mat-label class="required-field-after">Code</mat-label>
              <mat-form-field appearance="outline">
                <input matInput data-lpignore="true" formControlName="code" required />
                <mat-error *ngIf="editHolidayFormGroup.get('code').hasError('required') || editHolidayFormGroup.get('code').hasError('whitespace')">
                  {{ holidayErrorMessage.CODE_REQUIRED }}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="form-group-flex-column">
              <mat-label class="required-field-after">Name</mat-label>
              <mat-form-field appearance="outline">
                <input matInput data-lpignore="true" formControlName="name" required />
                <mat-error *ngIf="editHolidayFormGroup.get('name').hasError('required') || editHolidayFormGroup.get('name').hasError('whitespace')">
                  {{ holidayErrorMessage.NAME_REQUIRED }}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="form-group-flex-column">
              <mat-label class="required-field-after">Description</mat-label>
              <mat-form-field appearance="outline">
                <input matInput data-lpignore="true" formControlName="description" required />
                <mat-error *ngIf="editHolidayFormGroup.get('description').hasError('required') || editHolidayFormGroup.get('description').hasError('whitespace')">
                  {{ holidayErrorMessage.DESCRIPTION_REQUIRED }}
                </mat-error>
              </mat-form-field>
            </div>
          </div>
          <div fxLayout="row wrap" fxLayoutAlign="end">
            <button mat-raised-button class="plain-button" type="button" (click)="onClose()">Cancel</button>
            <button mat-raised-button class="theme-button" type="submit">Save</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
